import { GetServerSideProps } from 'next'
import { useQuery } from 'react-query'

import { Container } from '@components/Container'
import { AppLayout } from '@components/layouts/AppLayout'
import { OgShare } from '@components/OgShare'
import { BASE_URL } from '@configs/config'
import { useConsentAction } from '@hooks/consent/useConsentAction'
import { Loading } from '@components/Loading'
import { maintenanceHandler } from '@lib/maintenanceHandler'

export default function TermsOfUse({ url }: { url: string }) {
  const consentClient = useConsentAction()
  const { data, isLoading } = useQuery('pdpa', () =>
    consentClient.getPDPAConsent()
  )

  return (
    <AppLayout>
      <OgShare url={url} />
      <Container>
        {isLoading || !data ? (
          <Loading className='mx-auto' />
        ) : (
          <div
            className='about-coin text-secondary dark:text-dark-10 py-[50px] tablet-mobile:py-[20px] tablet:px-[20px] mobile:px-[10px] text-sm '
            dangerouslySetInnerHTML={{ __html: data.termsOfUse }}
          />
        )}
      </Container>
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  return maintenanceHandler({
    url: `${BASE_URL}${req.url}`,
  })
}
